import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from 'vuex';
import topTitle from '@/components/title.vue';
import infoForm from '../components/infoForm.vue';
import planExplanation from '../components/planExplanation.vue';
import { insuranceResource, mainPlanResource } from '@/views/insurance/insuranceManage/request';
import { planRelateData } from '@/views/policy/customerManage/request';
import { policyBatchSave, policyBatchCheckField } from '../request2';
export default {
  components: {
    topTitle,
    infoForm,
    planExplanation
  },
  data() {
    return {
      form: {
        attachValue: [],
        areaCodeValue: [],
        areaCode: '',
        planId: undefined
      },
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        className: 'td-bg'
      }, {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: 'amount',
        scopedSlots: {
          customRender: 'amount'
        },
        className: 'td-bg'
      }],
      tableData: [],
      continueState: false,
      explanationVisible: false,
      insuranceList: [],
      planList: [],
      attachOptions: [],
      hasAttachInfo: false,
      rearOptions: [],
      isAreaPrice: false,
      templateRenderList: [],
      formResult: false,
      insureForm: [],
      discountInfo: [],
      checkFieldData: []
    };
  },
  computed: {
    topRules() {
      return {
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }],
        planId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保险方案'),
          trigger: 'change'
        }],
        areaCodeValue: [{
          required: true,
          message: this.$t('请选择') + this.$t('地区'),
          trigger: 'change'
        }],
        add: {
          required: false,
          validator: this.addValidor,
          trigger: 'change'
        }
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  created() {
    this.getProduction();
  },
  methods: {
    addValidor(rule, value, callback) {
      if (this.form.attachValue.length) {
        console.log(123, this.tableData);
        if (this.tableData.findIndex(item => {
          var _item$attachPlan;
          return !((_item$attachPlan = item.attachPlan) !== null && _item$attachPlan !== void 0 && _item$attachPlan.length);
        }) > -1) {
          return callback(new Error('附加险保障额度不能为空'));
        }
      }
      callback();
    },
    async getProduction() {
      this.insuranceList = await insuranceResource({
        position: 'batchPolicy'
      });
    },
    async changeInsurance() {
      this.resetInfo();
      this.form.planId = undefined;
      if (this.form.insuranceId) {
        var _this$insuranceList$f;
        this.form.applicationId = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId).applicationId;
        const res = await mainPlanResource({
          insuranceId: (_this$insuranceList$f = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f === void 0 ? void 0 : _this$insuranceList$f.id
        });
        this.planList = res.items.map(item => {
          item.rightsCont = JSON.parse(item.rights);
          return item;
        });
      }
    },
    changePlan() {
      console.log(this.form.planId);
      let arr = this.planList.filter(item => item.id === this.form.planId);
      this.resetInfo();
      if (arr.length) {
        let selectPlanInfo = arr[0];
        this.$set(this.form, 'wait', selectPlanInfo.duration);
        //是否是区域保费
        this.isAreaPrice = selectPlanInfo.priceType === 'AREA_PRICE' ? true : false;
        let defaultValue = selectPlanInfo.priceType === 'AREA_PRICE' ? undefined : selectPlanInfo.price;
        this.$set(this.form, 'premiumPrice', defaultValue);
        //区域保费得下拉选择数据
        this.priceMap = {};
        const formatShowArea = (data, price) => {
          const result = data.map(item => {
            let obj = {};
            if (item.city && item.city.length) {
              obj.children = formatShowArea(item.city, item.price);
            }
            this.priceMap[item.code] = price || item.price;
            obj.value = item.code;
            obj.label = item.name;
            obj.areaIndex = item.areaIndex;
            return obj;
          });
          return result;
        };
        let allShowArea = selectPlanInfo.allShowArea ? JSON.parse(selectPlanInfo.allShowArea) : [];
        this.rearOptions = formatShowArea(allShowArea);
        //附加险信息
        this.attachOptions = selectPlanInfo.attachInfo && JSON.parse(selectPlanInfo.attachInfo);
        if (this.attachOptions) {
          this.hasAttachInfo = true; //控制是否展示附加险信息
          this.attachOptions.forEach(item => {
            if (item.buyLimit === 1) {
              item.disabled = true;
              item.allowClear = false;
              this.form.attachValue.push(item.attachId);
            }
          });
        }
        this.changeAdditional();
      }
      this.getPlanRelateData();
    },
    resetInfo() {
      this.hasAttachInfo = false; //清空附加险信息
      this.isAreaPrice = false; //区域保费信息清空
      this.rearOptions = []; //区域保费信息清空
      this.applicantList = []; //清空投保人信息
      this.tableData = []; //清空已选择的附加险方案信息
      this.form.attachValue = []; //清空已选择的附加险
      this.form.areaCodeValue = [];
      this.form.areaCode = ''; //区域保费的区域的code
    },
    amountSelect(value, record) {
      let attachPLan = record.attachPlan && Array.isArray(record.attachPlan) && record.attachPlan.filter(item => item.id === value);
      if (attachPLan.length) {
        this.$set(record, 'price', attachPLan[0].price);
        this.$set(record, 'mark', attachPLan[0].mark);
        this.$set(record, 'attachPlanId', value);
        this.tableData = [...this.tableData];
      }
    },
    changeAdditional(e) {
      this.tableData = [];
      this.form.attachValue && this.form.attachValue.forEach(value => {
        let selectItem = this.attachOptions.filter(item => item.attachId === value);
        if (selectItem.length) {
          let item = selectItem[0];
          //默认选中第一个方案
          if (!item.attachPlan) {
            //保障额度一个都没有的情况
            item.attachPlanId = '-';
            item.price = '-';
            item.amount = '-';
          } else {
            var _item$attachPlan2, _item$attachPlan3, _item$attachPlan4;
            item.attachPlanId = item.attachPlanId || ((_item$attachPlan2 = item.attachPlan) === null || _item$attachPlan2 === void 0 || (_item$attachPlan2 = _item$attachPlan2[0]) === null || _item$attachPlan2 === void 0 ? void 0 : _item$attachPlan2.id) || '-';
            item.price = item.price || ((_item$attachPlan3 = item.attachPlan) === null || _item$attachPlan3 === void 0 || (_item$attachPlan3 = _item$attachPlan3[0]) === null || _item$attachPlan3 === void 0 ? void 0 : _item$attachPlan3.price) || '-';
            item.mark = item.mark || ((_item$attachPlan4 = item.attachPlan) === null || _item$attachPlan4 === void 0 || (_item$attachPlan4 = _item$attachPlan4[0]) === null || _item$attachPlan4 === void 0 ? void 0 : _item$attachPlan4.mark) || '-';
            if (item.attachPlan.length === 1) {
              //只有一个方案的直接保障额度使用文本展示
              item.amount = item.amount || item.attachPlan[0].amount;
            }
          }
          this.tableData.push(item);
        }
      });
    },
    areaChange(value, selectOption) {
      let key = value[value.length - 1];
      this.$set(this.form, 'areaCode', key);
    },
    getPlanRelateData() {
      var _this$insuranceList$f2;
      //根据保险方案获取干系人的相关信息以及折扣的信息
      if (!this.form.planId) {
        return;
      }
      const {
        customerId,
        structureId
      } = this.accountInfo;
      let params = {
        customerId,
        structureId,
        insuranceId: (_this$insuranceList$f2 = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f2 === void 0 ? void 0 : _this$insuranceList$f2.id,
        insurancePlanId: this.form.planId,
        applicationId: this.form.applicationId
      };
      this.applicantTypeTemOption = [];
      this.insuredTemplate = [];
      planRelateData(params).then(res => {
        if (res) {
          this.discountInfo = res.discountInfo;
          Array.isArray(res.templateRenderList) && res.templateRenderList.forEach((item, index) => {
            if (item.code === 'applicant') {
              if (item.item[0].inputKey === 'COMPANY') {
                res.templateRenderList[index].item.push(...item.company);
                // applicantInfo = item.company;
              }
              if (item.item[0].inputKey === 'NATURAL_PERSON') {
                res.templateRenderList[index].item.push(...item.personal);
                // applicantInfo = item.personal;
              }
              if (item.item[0].code === 'applicantType') {
                res.templateRenderList[index].item[0].display = 'radio';
              }
            }
            item.item.forEach((item1, index1) => {
              if (item1.display == 'dropDownBox(region)') {
                res.templateRenderList[index].item[index1].inputKey = [];
              }
              if (item1.display == 'dropDownBox' && !item1.inputKey) {
                res.templateRenderList[index].item[index1].inputKey = undefined;
              }
              if (item1.name == '验证码') {
                res.templateRenderList[index].item.splice(index1, 1);
              }
            });
          });
          this.templateRenderList = res.templateRenderList;
        }
      });
    },
    formatFormTemplate(data) {
      if (!Array.isArray(data)) {
        return [];
      }
      return data.map(item => {
        let obj = {
          code: item.code,
          display: item.display,
          id: item.id,
          name: item.name,
          type: item.type,
          valData: undefined,
          selectarr: [],
          required: item.isOptional === 0
        };
        if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
          obj.selectarr = item.value;
        }
        return obj;
      });
    },
    onUpdateForm(value) {
      this.insureForm = value;
    },
    onSave() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.checkFieldData = [];
          this.formResult = true;
        }
      });
    },
    validate(val) {
      this.formResult = false;
      if (val) {
        this.toSaveData();
      }
    },
    async toSaveData() {
      var _this$insuranceList$f3;
      let params = {
        insuranceId: (_this$insuranceList$f3 = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f3 === void 0 ? void 0 : _this$insuranceList$f3.id,
        insuredInfo: this.getInsuredInfo(1)
      };
      const res = await policyBatchCheckField(params);
      let passRes = res.insuredInfo.findIndex(i => i.isCheck);
      if (passRes > -1) {
        // 传回有错误信息数据
        this.checkFieldData = res.insuredInfo.map(item => {
          if (item.insured) {
            item.insured = item.insured[0];
          }
          return item;
        });
      } else {
        this.checkFieldData = [];
        await this.organizeSaveParams();
      }
    },
    // 组织提交数据
    async organizeSaveParams() {
      var _this$insuranceList$f4;
      let insuredInfo = this.getInsuredInfo(2).map(item => {
        if (item.insured) {
          item.insured = item.insured[0];
        }
        return item;
      });
      let params = {
        customerId: this.accountInfo.customerId,
        insuranceId: (_this$insuranceList$f4 = this.insuranceList.find(i => i.insuranceCustomerId === this.form.insuranceId)) === null || _this$insuranceList$f4 === void 0 ? void 0 : _this$insuranceList$f4.id,
        applicationId: this.form.applicationId,
        customerInsuranceId: this.form.insuranceId,
        insuredInfo
      };
      await policyBatchSave(params);
      this.$message.destroy();
      this.$message.success(this.$t('保存成功'));
      if (this.continueState) {
        this.$refs.formRef.resetFields();
        this.resetInfo();
        this.templateRenderList = [];
      } else {
        this.$router.push({
          name: 'customInsureManage'
        });
      }
    },
    /**
     * @description 生成insuredInfo参数
     * @param {*} key 1 验证接口 2 保存接口
     */
    getInsuredInfo(key) {
      let insuranceInfo = this.insuranceList.find(i => i.insuranceCustomerId == this.form.insuranceId);
      let planInfo = this.planList.find(i => i.id == this.form.planId);
      let insuredInfo = [];
      let insuranceAttachPlanCode = this.tableData.map(i => i.mark).join(',');
      let attachInfo = this.tableData.map(item => {
        item.attachPlan = item.attachPlan.filter(i => insuranceAttachPlanCode.includes(i.mark));
        return item;
      });
      this.insureForm.forEach(item => {
        let obj = {};
        item.forEach(item1 => {
          obj[item1.code] = [];
          item1.item.forEach(item2 => {
            let obj1 = {};
            obj1.code = item2.code;
            obj1.name = item2.name;
            obj1.display = item2.display;
            obj1.id = item2.id;
            obj1.type = item2.type;
            obj1.valData = item2.inputKey;
            if (item2.value) {
              var _item2$value$find;
              obj1.valData1 = ((_item2$value$find = item2.value.find(i => i.key == item2.inputKey)) === null || _item2$value$find === void 0 ? void 0 : _item2$value$find.value) || '';
            }
            if (item2.display == 'dropDownBox(region)') {
              obj1.defaultValue = item2.inputKey;
              obj1.valData = item2.inputValue;
            }
            obj[item1.code].push(obj1);
          });
          let areaName = '';
          let areaPrice = '';
          let areaIndex;
          if (planInfo.allShowArea && JSON.parse(planInfo.allShowArea)) {
            JSON.parse(planInfo.allShowArea).forEach(item => {
              if (this.form.areaCodeValue.includes(item.code)) {
                var _item$city$find, _item$city$find2, _item$city$find3;
                areaName = item.name + ' ' + ((_item$city$find = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find === void 0 ? void 0 : _item$city$find.name);
                areaPrice = (_item$city$find2 = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find2 === void 0 ? void 0 : _item$city$find2.price;
                areaIndex = (_item$city$find3 = item.city.find(i => this.form.areaCodeValue.includes(i.code))) === null || _item$city$find3 === void 0 ? void 0 : _item$city$find3.areaIndex;
              }
            });
          }
          if (key == 2 && item1.code == 'commonInfo' || key == 2 && item.findIndex(i => i.code == 'commonInfo') == -1) {
            if (item1.code == 'commonInfo') {
              var _this$form$areaCodeVa, _this$discountInfo$fi, _this$discountInfo$, _this$discountInfo$fi2, _this$discountInfo$2, _this$discountInfo$fi3, _this$discountInfo$3;
              obj[item1.code] = {
                commonTemplate: (obj === null || obj === void 0 ? void 0 : obj[item1.code]) || null,
                // operateDate:
                insuranceCustomerCode: insuranceInfo.insuranceCustomerCode,
                insuranceName: insuranceInfo.customerInsuranceName,
                insurancePlanName: planInfo.name,
                insurancePlanCode: planInfo.mark,
                insuranceAttachPlanCode,
                price: planInfo.price,
                insurancePlanAmount: planInfo.amount,
                areaCode: ((_this$form$areaCodeVa = this.form.areaCodeValue) === null || _this$form$areaCodeVa === void 0 ? void 0 : _this$form$areaCodeVa[1]) || '',
                areaName,
                areaPrice: areaPrice || '',
                discountMode: areaName ? (_this$discountInfo$fi = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi === void 0 ? void 0 : _this$discountInfo$fi.discountMode : (_this$discountInfo$ = this.discountInfo[0]) === null || _this$discountInfo$ === void 0 ? void 0 : _this$discountInfo$.discountMode,
                discountRatio: areaName ? (_this$discountInfo$fi2 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi2 === void 0 ? void 0 : _this$discountInfo$fi2.discountRatio : (_this$discountInfo$2 = this.discountInfo[0]) === null || _this$discountInfo$2 === void 0 ? void 0 : _this$discountInfo$2.discountRatio,
                discountAmount: areaName ? (_this$discountInfo$fi3 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi3 === void 0 ? void 0 : _this$discountInfo$fi3.discountAmount : (_this$discountInfo$3 = this.discountInfo[0]) === null || _this$discountInfo$3 === void 0 ? void 0 : _this$discountInfo$3.discountAmount,
                attachInfo,
                insureCount: 1
              };
            } else {
              var _this$form$areaCodeVa2, _this$discountInfo$fi4, _this$discountInfo$4, _this$discountInfo$fi5, _this$discountInfo$5, _this$discountInfo$fi6, _this$discountInfo$6;
              obj['commonInfo'] = {
                insuranceCustomerCode: insuranceInfo.insuranceCustomerCode,
                insuranceName: insuranceInfo.customerInsuranceName,
                insurancePlanName: planInfo.name,
                insurancePlanCode: planInfo.mark,
                insuranceAttachPlanCode,
                price: planInfo.price,
                insurancePlanAmount: planInfo.amount,
                areaCode: ((_this$form$areaCodeVa2 = this.form.areaCodeValue) === null || _this$form$areaCodeVa2 === void 0 ? void 0 : _this$form$areaCodeVa2[1]) || '',
                areaName,
                areaPrice: areaPrice || '',
                discountMode: areaName ? (_this$discountInfo$fi4 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi4 === void 0 ? void 0 : _this$discountInfo$fi4.discountMode : (_this$discountInfo$4 = this.discountInfo[0]) === null || _this$discountInfo$4 === void 0 ? void 0 : _this$discountInfo$4.discountMode,
                discountRatio: areaName ? (_this$discountInfo$fi5 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi5 === void 0 ? void 0 : _this$discountInfo$fi5.discountRatio : (_this$discountInfo$5 = this.discountInfo[0]) === null || _this$discountInfo$5 === void 0 ? void 0 : _this$discountInfo$5.discountRatio,
                discountAmount: areaName ? (_this$discountInfo$fi6 = this.discountInfo.find(i => i.areaIndex === areaIndex)) === null || _this$discountInfo$fi6 === void 0 ? void 0 : _this$discountInfo$fi6.discountAmount : (_this$discountInfo$6 = this.discountInfo[0]) === null || _this$discountInfo$6 === void 0 ? void 0 : _this$discountInfo$6.discountAmount,
                attachInfo,
                insureCount: 1
              };
            }
          }
        });
        if (obj.insured) {
          obj.insured = [obj.insured];
        }
        insuredInfo.push(obj);
      });
      return insuredInfo;
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    openExplanation() {
      this.explanationVisible = true;
    }
  }
};